import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import { formatPrice } from '@grandvisionhq/utils';

const BestPrice = (_param)=>{
    var { amount , currencyCode , className , isCentAmount =false  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "amount",
        "currencyCode",
        "className",
        "isCentAmount"
    ]);
    const { getFormattedLabel , locale  } = useIntl();
    return /*#__PURE__*/ React__default.createElement("div", swcHelpers.extends({
        className: classnames('best-price', className)
    }, rest), getFormattedLabel('products.recentLowestPrice', {
        labelData: {
            recentLowestPrice: formatPrice({
                locale,
                value: amount,
                currency: currencyCode,
                isCentAmount
            })
        }
    }));
};
var BestPrice$1 = BestPrice;

export { BestPrice$1 as default };
//# sourceMappingURL=BestPrice.js.map
